import { render, staticRenderFns } from "./not_found.vue?vue&type=template&id=8f1f0c54&scoped=true"
import script from "./not_found.vue?vue&type=script&lang=js"
export * from "./not_found.vue?vue&type=script&lang=js"
import style0 from "./not_found.vue?vue&type=style&index=0&id=8f1f0c54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1f0c54",
  null
  
)

export default component.exports